module.exports = __webpack_public_path__ + "media/94.5c270305.mp3";